import {
  GoodReceivedStateTypes,
  GoodReceivedActionTypes,
} from "./GoodReceived.type";
import { resetApiCallState } from "../Utils";

const INITIAL_STATE: GoodReceivedStateTypes = {
  fetchAll: resetApiCallState([]),
  fetchReport: resetApiCallState([]),
  fetchValidation: resetApiCallState([]),
  fetchOne: resetApiCallState(null),
};

const GoodReceivedReducer = (
  state: GoodReceivedStateTypes = INITIAL_STATE,
  action: any
): GoodReceivedStateTypes => {
  switch (action.type) {
    case GoodReceivedActionTypes.FETCH_ALL_GOOD_RECEIVED:
      return {
        ...state,
        fetchAll: {
          error: null,
          payload: [],
          isPending: true,
          isSuccessful: false,
        },
      };
    case GoodReceivedActionTypes.FETCH_ALL_GOOD_RECEIVED_RESET:
      return {
        ...state,
        fetchAll: resetApiCallState([]),
      };
    case GoodReceivedActionTypes.FETCH_ALL_GOOD_RECEIVED_FAILURE:
      return {
        ...state,
        fetchAll: {
          payload: [],
          isPending: false,
          isSuccessful: false,
          error: action.payload,
        },
      };
    case GoodReceivedActionTypes.FETCH_ALL_GOOD_RECEIVED_SUCCESS:
      return {
        ...state,
        fetchAll: {
          error: null,
          isPending: false,
          isSuccessful: true,
          payload: action.payload,
        },
      };

    // -------------

    case GoodReceivedActionTypes.FETCH_ONE_GOOD_RECEIVED:
      return {
        ...state,
        fetchOne: {
          error: null,
          payload: null,
          isPending: true,
          isSuccessful: false,
        },
      };
    case GoodReceivedActionTypes.FETCH_ONE_GOOD_RECEIVED_RESET:
      return {
        ...state,
        fetchOne: resetApiCallState(null),
      };
    case GoodReceivedActionTypes.FETCH_ONE_GOOD_RECEIVED_FAILURE:
      return {
        ...state,
        fetchOne: {
          payload: null,
          isPending: false,
          isSuccessful: false,
          error: action.payload,
        },
      };
    case GoodReceivedActionTypes.FETCH_ONE_GOOD_RECEIVED_SUCCESS:
      return {
        ...state,
        fetchOne: {
          error: null,
          isPending: false,
          isSuccessful: true,
          payload: action.payload,
        },
      };

    // -------------

    case GoodReceivedActionTypes.FETCH_GOOD_RECEIVED_REPORT:
      return {
        ...state,
        fetchReport: {
          error: null,
          payload: [],
          isPending: true,
          isSuccessful: false,
        },
      };
    case GoodReceivedActionTypes.FETCH_GOOD_RECEIVED_REPORT_RESET:
      return {
        ...state,
        fetchReport: resetApiCallState([]),
      };
    case GoodReceivedActionTypes.FETCH_GOOD_RECEIVED_REPORT_FAILURE:
      return {
        ...state,
        fetchReport: {
          payload: [],
          isPending: false,
          isSuccessful: false,
          error: action.payload,
        },
      };
    case GoodReceivedActionTypes.FETCH_GOOD_RECEIVED_REPORT_SUCCESS:
      return {
        ...state,
        fetchReport: {
          error: null,
          isPending: false,
          isSuccessful: true,
          payload: action.payload,
        },
      };

    // -------------

    case GoodReceivedActionTypes.FETCH_GOOD_RECEIVED_VALIDATION:
      return {
        ...state,
        fetchValidation: {
          error: null,
          payload: [],
          isPending: true,
          isSuccessful: false,
        },
      };
    case GoodReceivedActionTypes.FETCH_GOOD_RECEIVED_VALIDATION_RESET:
      return {
        ...state,
        fetchValidation: resetApiCallState([]),
      };
    case GoodReceivedActionTypes.FETCH_GOOD_RECEIVED_VALIDATION_FAILURE:
      return {
        ...state,
        fetchValidation: {
          payload: [],
          isPending: false,
          isSuccessful: false,
          error: action.payload,
        },
      };
    case GoodReceivedActionTypes.FETCH_GOOD_RECEIVED_VALIDATION_SUCCESS:
      return {
        ...state,
        fetchValidation: {
          error: null,
          isPending: false,
          isSuccessful: true,
          payload: action.payload,
        },
      };

    default:
      return state;
  }
};

export default GoodReceivedReducer;
